import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "login" }
const _hoisted_2 = { class: "login-form" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "h1" }
const _hoisted_5 = { class: "mt-4" }
const _hoisted_6 = { class: "field form-group" }
const _hoisted_7 = {
  key: 0,
  class: "auth-error"
}
const _hoisted_8 = {
  key: 1,
  class: "auth-error"
}
const _hoisted_9 = {
  key: 2,
  class: "auth-error"
}
const _hoisted_10 = { class: "field form-group d-flex align-items-center justify-content-center" }
const _hoisted_11 = ["disabled"]

import {
  ref,
  computed,
  onMounted,
  watch,
  getCurrentInstance,
} from "vue";

import { AdapterApiService } from "@pages/_adapter";
import { notify } from "@/app/notifications";
import { AdapterAuthService } from "./adapter";
import { useRoute, useRouter } from "vue-router";

// Определение пропсов компонента


export default /*#__PURE__*/_defineComponent({
  __name: 'forgot-password-finish-page',
  props: {
  isCompact: { type: Boolean, value: true },
  msg: { type: String, default: "" },
},
  setup(__props) {

// Импорты из Vue 3 Composition API
const props = __props;

const authErrorMessage = ref("Passwords are different!");
const adapter = AdapterAuthService.getInstance();

const password1 = ref("");
const password2 = ref("");

const isAuthNoError = computed(() => {
  return password1.value === password2.value;
});
const isBlankError = computed(() => {
  return password1.value == "";
});

const isIncorrectToken = ref(false);

const passwordIsValid = computed(() => {
  return validatePassword(password1.value);
});

const route = useRoute();
const router = useRouter();
// const instance = getCurrentInstance();
onMounted(async () => {
  localStorage.setItem("locale", route.query?.lng.toString() || "cz");
});
async function onFinish() {
  let res = await adapter.recoverPassword({
    Email: route.query.email.toString(),
    Password: password1.value,
    Token: route.query.token.toString(),
  });

  if (res.IsSuccess) {
    isIncorrectToken.value = false;
    router.push({ name: "Login" });
  } else {
    isIncorrectToken.value = true;
    authErrorMessage.value = res.ErrorMessage;
  }
}

// function validEmail(value: string): boolean {
//   // Регулярное выражение для проверки валидности email
//   const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

//   // Проверяем, что строка не пуста и соответствует паттерну
//   return emailPattern.test(value);
// }
function validatePassword(password) {
  const regex = /^(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,}$/;
  return regex.test(password);
}

return (_ctx: any,_cache: any) => {
  const _component_ui_input = _resolveComponent("ui-input")!
  const _component_layout_without_sidebar = _resolveComponent("layout-without-sidebar")!

  return (_openBlock(), _createBlock(_component_layout_without_sidebar, {
    isShowSideBar: false,
    isLogin: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("forgot-password.Recovery Password")), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("forgot-password.Create a new")), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_ui_input, {
              modelValue: password1.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password1).value = $event)),
              type: "password",
              headerText: "Password",
              warningMsg: _ctx.$t('FillThisField'),
              required: ""
            }, null, 8, ["modelValue", "warningMsg"]),
            _createVNode(_component_ui_input, {
              modelValue: password2.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password2).value = $event)),
              class: "mt-4",
              type: "password",
              headerText: "Confirm Password",
              warningMsg: _ctx.$t('FillThisField'),
              required: ""
            }, null, 8, ["modelValue", "warningMsg"])
          ]),
          (passwordIsValid.value && !isAuthNoError.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(authErrorMessage.value), 1))
            : _createCommentVNode("", true),
          (!passwordIsValid.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t("forgot-password.The password must")), 1))
            : _createCommentVNode("", true),
          (isIncorrectToken.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Incorrect token!"))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              class: "ui_continue_button",
              onClick: onFinish,
              disabled: !isAuthNoError.value || isBlankError.value || !passwordIsValid.value
            }, [
              _createTextVNode("  "),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("Send")), 1)
            ], 8, _hoisted_11)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})